import React, {useContext} from "react";
import {Pressable, View, Image, Text} from "react-native";
import MainStyle from "../../MainStyle";
import ticket_icon from '../assets/img/icons/ticket_icon.svg';
import cross_icon from '../assets/img/icons/crosshair-line 1.svg';
import trophy_icon from '../assets/img/icons/trophy-line 2.svg';
import friends from '../assets/img/icons/friends.svg';
import {MaterialCommunityIcons} from '@expo/vector-icons';
import {useNavigation} from "@react-navigation/native";
import {StoreContext} from "./StoreContextProvider";
import {colors} from "../assets/styles/colors";
import HelpLinkModalTrigger from "../modals/HelpLinksModal";

type Props = { page: 'challenges' | 'account' | 'promos' | 'tournaments' |'FriendsScreen' };

const BottomNavigation = (props: Props) => {
  const {page} = props;
  const navigation: any = useNavigation();
  const Context = useContext(StoreContext);
  const {extendedUserData} = Context;

  return (
    <View style={[MainStyle.row, MainStyle.j_c_s_between, MainStyle.m_x_auto]}>
      <Pressable onPress={() => navigation.navigate('challenges')} style={styles.item}>
        <View style={[...styles.btn, page === 'challenges' && styles.active]}>
          <Image source={cross_icon as any} style={[MainStyle.w_24, MainStyle.h_24]}/>
        </View>
        <Text style={styles.text}>GAMES</Text>
      </Pressable>

      <Pressable onPress={() => navigation.navigate('tournaments')} style={styles.item}>
        <View style={[...styles.btn, page === 'tournaments' && styles.active]}>
          <Image source={trophy_icon as any} style={[MainStyle.w_24, MainStyle.h_24]}/>
        </View>
        <Text style={styles.text}>Tourney</Text>
      </Pressable>

      <Pressable onPress={() => navigation.navigate('FriendsScreen')} style={styles.item}>
        <View style={[...styles.btn, page === 'FriendsScreen' && styles.active]}>
          <Image source={friends as any} style={{width:22,height:19}}/>
        </View>
        <Text style={styles.text}>friends</Text>
      </Pressable>

      <Pressable onPress={() => navigation.navigate('account')} style={styles.item}>
        <View style={[...styles.btn, page === 'account' && styles.active]}>
          <MaterialCommunityIcons name="account-circle-outline" size={24} color="white"/>
        </View>
        <Text style={styles.text}>PROFILE</Text>
      </Pressable>

      <Pressable onPress={() => navigation.navigate('promos')} style={styles.item}>
        <View style={[...styles.btn, page === 'promos' && styles.active]}>
          <Image source={ticket_icon as any} style={[MainStyle.w_24, MainStyle.h_24]}/>
          {extendedUserData.hasNewBonus && <View style={styles.notification}/>}
        </View>
        <Text style={styles.text}>PROMOS</Text>
      </Pressable>

      <HelpLinkModalTrigger
        page="bottom_nav" bw={1} borderColor={colors.settings_border} bg={colors.help_icon} w={48} h={48} br={40}
        alignItems="center" justifyContent="center"
      />
    </View>
  );
};

const styles = {
  btn: [
    MainStyle.w_48, MainStyle.h_48, MainStyle.b_r_40, MainStyle.bg_settings, MainStyle.a_i_c, MainStyle.j_c_c,
    MainStyle.b_c_settings_border, MainStyle.b_w_1, MainStyle.relative
  ],
  active: [MainStyle.bg_filter_chip, MainStyle.b_c_filter_chip_bg],
  text: [MainStyle.c_white, MainStyle.Barlow500, MainStyle.f_s_12, MainStyle.t_t_u],
  item: [MainStyle.a_i_c, MainStyle.j_c_c, MainStyle.m_x_6],
  notification: [
    MainStyle.absolute, MainStyle.t_0, MainStyle.r__1, MainStyle.bg_warningText, MainStyle.b_r_16, MainStyle.w_12,
    MainStyle.h_12
  ]
};

export default React.memo(BottomNavigation);
